/**
 * BLOC GALERIE
 * Bloc pinné : les satellites s'agrandissent et sortent du cadre, avec un léger
 * zoom interne de leur image, pendant que la photo centrale prend le plein écran.
 * Le voile et le texte apparaissent pendant la fin du zoom.
 */
jQuery(document).ready(function ($) {

    const SCRUB_LONGUEUR = "250%"   // distance de scroll de la phase pinnée
    const SORTIE_SCALE = 1.8        // grossissement du cadre des satellites
    const SORTIE_ZOOM = 1.12        // zoom interne de l'image des satellites
    const SORTIE_MARGE = 1.15       // marge sur la diagonale, garantit la sortie de l'écran
    const FIN_EXPANSION = 0.75      // part du scrub consacrée à l'expansion
    const DEBUT_TEXTE = 0.4         // le texte démarre pendant le zoom
    const FIN_TEXTE = 0.8           // le reste du scrub sert de temps de pause sur l'image
    const DEBORDEMENT = 1.02        // la centrale dépasse légèrement l'écran en fin de course

    // animations réduites : aucun ScrollTrigger, le CSS affiche une composition statique
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
        return

    /**
     * Vecteur de sortie d'un satellite : direction du centre de la scène vers son
     * propre centre, amplifiée jusqu'à la diagonale du viewport.
     * Mesures de layout uniquement, insensibles aux transform déjà appliqués.
     */
    function vecteurSortie(satellite, scene) {
        const dx = (satellite.offsetLeft + satellite.offsetWidth / 2) - scene.offsetWidth / 2
        const dy = (satellite.offsetTop + satellite.offsetHeight / 2) - scene.offsetHeight / 2
        const norme = Math.sqrt(dx * dx + dy * dy) || 1
        const diagonale = Math.sqrt(window.innerWidth * window.innerWidth + window.innerHeight * window.innerHeight)
        const distance = diagonale * SORTIE_MARGE

        return {
            x: dx / norme * distance,
            y: dy / norme * distance
        }
    }

    /**
     * Géométrie d'arrivée de la photo centrale.
     *
     * La centrale fait 2.07:1 dans la composition alors que l'écran fait 1.78:1 :
     * un scale uniforme ne peut donc pas amener ses quatre coins sur les coins de
     * l'écran, il déborderait de 16% en largeur. On calcule donc deux échelles
     * distinctes, plus la translation qui amène son centre au centre de l'écran.
     *
     * fx, fy : échelles du cadre pour atteindre le viewport, débordement inclus
     * dx, dy : translation de recentrage (la centrale est alignée sur les
     *          satellites, pas centrée dans le cadre)
     *
     * Mesures fractionnaires obligatoires : offsetWidth arrondit à l'entier, ce
     * qui suffit à laisser un filet de fond visible sur les bords en fin de course.
     * Les rect du wrapper et de la scène sont insensibles aux transform de leurs
     * descendants, et leur différence reste juste même si le pin décale les deux.
     */
    function geometrieCentrale(wrap, scene) {
        const vw = window.innerWidth
        const vh = window.innerHeight
        const cadre = scene.getBoundingClientRect()
        const boite = wrap.getBoundingClientRect()

        if (!boite.width || !boite.height)
            return { fx: 1, fy: 1, dx: 0, dy: 0 }

        // position du wrapper dans la scène, en valeurs fractionnaires
        const posX = boite.left - cadre.left
        const posY = boite.top - cadre.top

        // la scène est centrée dans le bloc, lui-même plein écran quand il est pinné
        const cx = (vw - cadre.width) / 2 + posX + boite.width / 2
        const cy = (vh - cadre.height) / 2 + posY + boite.height / 2

        return {
            fx: vw / boite.width * DEBORDEMENT,
            fy: vh / boite.height * DEBORDEMENT,
            dx: vw / 2 - cx,
            dy: vh / 2 - cy
        }
    }

    $(".bloc_galerie").each(function () {
        const bloc = this
        const scene = bloc.querySelector(".scene")
        const satellites = gsap.utils.toArray(bloc.querySelectorAll(".satellite"))
        const wrap = bloc.querySelector(".centrale_wrap")
        const centrale = bloc.querySelector(".centrale")
        const voile = bloc.querySelector(".voile")
        const final = bloc.querySelector(".final")

        if (!scene)
            return

        const imageCentrale = centrale ? centrale.querySelector("img") : null

        /**
         * Géométrie mise en cache : recalculée à l'init et à chaque refresh de
         * ScrollTrigger, donc à chaque redimensionnement. Surtout pas dans le
         * onUpdate, qui forcerait une lecture de layout à chaque frame.
         */
        let geo = geometrieCentrale(wrap || scene, scene)

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: bloc,
                start: "top top",
                end: "+=" + SCRUB_LONGUEUR,
                pin: true,
                scrub: true,
                anticipatePin: 1,
                invalidateOnRefresh: true,
                onRefresh: function () {
                    if (wrap)
                        geo = geometrieCentrale(wrap, scene)
                }
            }
        })

        // sortie des satellites, avec zoom interne de l'image
        satellites.forEach(function (satellite) {
            tl.to(satellite, {
                scale: SORTIE_SCALE,
                x: function () {
                    return vecteurSortie(satellite, scene).x
                },
                y: function () {
                    return vecteurSortie(satellite, scene).y
                },
                autoAlpha: 0,
                ease: "power1.in",
                duration: FIN_EXPANSION
            }, 0)

            const image = satellite.querySelector("img")

            if (image) {
                tl.to(image, {
                    scale: SORTIE_ZOOM,
                    ease: "power1.inOut",
                    duration: FIN_EXPANSION
                }, 0)
            }
        })

        /**
         * La photo centrale rejoint exactement le viewport, coins sur coins.
         *
         * Le cadre reçoit deux échelles distinctes, l'image intérieure la
         * contre-échelle inverse : à l'écran la photo subit toujours un
         * grossissement uniforme, donc aucune déformation, et elle remplit
         * exactement son cadre à chaque instant.
         *
         * Tout passe par un seul tween proxy plutôt que par des tweens séparés :
         * interpolés indépendamment, cadre et contre-échelle se désynchroniseraient
         * en cours de route et laisseraient des filets vides sur les bords.
         */
        if (centrale && wrap) {
            const etat = { p: 0 }

            tl.to(etat, {
                p: 1,
                ease: "power1.inOut",
                duration: FIN_EXPANSION,
                onUpdate: function () {
                    const fx = 1 + (geo.fx - 1) * etat.p
                    const fy = 1 + (geo.fy - 1) * etat.p
                    const m = Math.max(fx, fy)

                    gsap.set(centrale, {
                        scaleX: fx,
                        scaleY: fy,
                        x: geo.dx * etat.p,
                        y: geo.dy * etat.p
                    })

                    if (imageCentrale) {
                        gsap.set(imageCentrale, {
                            scaleX: m / fx,
                            scaleY: m / fy
                        })
                    }
                }
            }, 0)
        }

        // voile et texte pendant la fin du zoom
        if (voile) {
            tl.to(voile, {
                opacity: .55,
                ease: "none",
                duration: FIN_TEXTE - DEBUT_TEXTE
            }, DEBUT_TEXTE)
        }

        if (final) {
            tl.fromTo(final,
                { autoAlpha: 0, y: 30 },
                {
                    autoAlpha: 1,
                    y: 0,
                    ease: "power1.out",
                    duration: FIN_TEXTE - DEBUT_TEXTE
                },
                DEBUT_TEXTE)
        }

        /**
         * Tween vide de fin : il porte la timeline jusqu'à 1 pour créer un temps
         * de pause sur l'image plein écran avant que le pin ne se relâche.
         * Sans lui, le scrub étirerait l'animation sur toute la distance de scroll.
         */
        tl.to({}, { duration: 1 - FIN_TEXTE }, FIN_TEXTE)
    })

})
